import * as React from "react";

const TermsIconSVG = ({
    color = "#F8FAFC"
}) => (
    <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40">
        <path
            fill={color}
            d="M16 17v-2h9v2zm0 3v-2h9v2zm3 8.038h-7zM19 30h-6a2.9 2.9 0 0 1-2.125-.875A2.9 2.9 0 0 1 10 27v-3h3V10h15v9.025a3.785 3.785 0 0 0-2 .35V12H15v12h6l-2 2h-7v1q0 .424.287.712.288.288.713.288h6zm2 0v-3.075l5.525-5.5q.225-.225.5-.325a1.6 1.6 0 0 1 .55-.1 1.5 1.5 0 0 1 1.075.45l.925.925q.2.225.313.5t.112.55q0 .274-.1.563a1.34 1.34 0 0 1-.325.512l-5.5 5.5zm7.5-6.575-.925-.925zm-6 5.075h.95l3.025-3.05-.45-.475-.475-.45-3.05 3.025zm3.525-3.525-.475-.45.925.925z"
        ></path>
    </svg>
);

export default TermsIconSVG;
